import { render, staticRenderFns } from "./OrderDestination.vue?vue&type=template&id=4d6e40c0&"
import script from "./OrderDestination.vue?vue&type=script&lang=js&"
export * from "./OrderDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports